import React, { useContext } from "react";
import { useMessageSource } from "react-message-source";
import { Route, Routes, useNavigate } from "react-router-dom";
import { UserContext } from "../../../context/userContext";
import PageContainer from "../../../ui/layout/page";
import PageFooter from "../../../ui/layout/page/footer";
import PageHeader from "../../../ui/layout/page/header";
import { RouteConfig } from "../../../route";

const Layout: React.FC<{ routes?: RouteConfig[] }> = ({ routes }) => {
  const { getMessage } = useMessageSource();
  const { email, logOut } = useContext(UserContext);
  const navigate = useNavigate();

  const login = () => {
    // jump to the login
    navigate("/login");
  };

  return (
    <PageContainer>
      <PageHeader
        onLogin={login}
        onLogout={logOut}
        username={email}
        loginText={getMessage("Header.login")}
        logoutText={getMessage("Header.logout")}
      />
      <Routes>
        {routes.map((route) => (
          <Route
            key={`${route.path}-${route.component}`}
            path={route.path}
            element={<route.component routes={route.routes} />}
          />
        ))}
      </Routes>
      <PageFooter />
    </PageContainer>
  );
};

export default Layout;
